/**
 * Identity facts the shell chrome reads (WP0-INT glue). Safe outside the
 * identity provider (tests, stories): answers false there.
 */
import { useSessionContext } from '../../modules/identity/index.js';

/** Where "Add an office" in the office selector leads (identity's Offices page). */
export const ADD_OFFICE_PATH = '/settings/offices';

/** True when the signed-in person may add offices (identity `canAddOffice`). */
export function useCanAddOffice(): boolean {
  try {
    return useSessionContext().session?.context.canAddOffice ?? false;
  } catch {
    return false;
  }
}
